import { render, staticRenderFns } from "./ExploreMore.vue?vue&type=template&id=5fabca30&"
import script from "./ExploreMore.vue?vue&type=script&lang=js&"
export * from "./ExploreMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports